export default {
    domain: "dev-103wff52.auth0.com",
    clientId: "ZFMMBiwH0IJRI0gFvvpAQ0iKQgP4PUFO",
};
